import i18n from 'i18next';

const errorCodeToI18nKey: Record<string, string> = {
  AUTH_INVALID_CREDENTIALS: 'apiErrors.invalidCredentials',
  AUTH_USER_NOT_FOUND: 'apiErrors.userNotFound',
  AUTH_USER_INACTIVE: 'apiErrors.accountDisabled',
  AUTH_TENANT_INACTIVE: 'apiErrors.accountDisabled',
  AUTH_TOKEN_INVALID: 'apiErrors.invalidToken',
  AUTH_TOKEN_EXPIRED: 'apiErrors.tokenExpired',
  AUTH_FORBIDDEN: 'apiErrors.accountLocked',
  RESET_TOKEN_INVALID: 'apiErrors.invalidToken',
  RATE_LIMIT_EXCEEDED: 'apiErrors.rateLimitExceeded',
  VALIDATION_ERROR: 'apiErrors.internalError',
  AUTH_SESSION_CONFLICT: 'apiErrors.sessionConflict',
  NETWORK_ERROR: 'apiErrors.networkError',
  // Keycloak migration
  PASSWORD_POLICY: 'apiErrors.passwordPolicy',
  AUTH_PASSWORD_UPDATE_REQUIRED: 'apiErrors.passwordUpdateRequired',
  AUTH_UNAVAILABLE: 'apiErrors.serviceUnavailable',
  RESET_ACCOUNT_CONFLICT: 'apiErrors.accountLocked',
  HANDOFF_CODE_INVALID: 'apiErrors.redirectFailed',
  HANDOFF_SESSION_MISMATCH: 'apiErrors.redirectFailed',
  HANDOFF_UNKNOWN_APP: 'apiErrors.redirectFailed',
  HANDOFF_KEYCLOAK_ONLY: 'apiErrors.redirectFailed',
  INTERNAL_ERROR: 'apiErrors.internalError',
};

export function getErrorMessage(errorCode?: string | null, fallbackKey = 'apiErrors.unknownError'): string {
  if (!errorCode) return i18n.t(fallbackKey);
  const key = errorCodeToI18nKey[errorCode];
  return key ? i18n.t(key) : i18n.t(fallbackKey, { code: errorCode });
}

export function extractApiError(error: unknown): string {
  if (error && typeof error === 'object' && 'response' in error) {
    const axiosError = error as { response?: { data?: { errorCode?: string; message?: string } } };
    const errorCode = axiosError.response?.data?.errorCode;
    return getErrorMessage(errorCode);
  }
  return getErrorMessage('NETWORK_ERROR');
}
